import { useMemo, useState } from "react";
import useAddresses from "../../api/address";
import { hasPermission } from "../../helpers/hasPermission";
import { validMapPoint } from "../../helpers/geo";
import { Permission } from "../../types/permission";
import { RecordCardsModalLazy } from "../publishers/async";
import { RemindersModal } from "../publishers/reminders";
import { NavMenu } from "./NavMenu";

export function NavPublishers() {
  const [showReminders, setShowReminders] = useState(false);
  const [showRecordCards, setShowRecordCards] = useState(false);
  const addresses = useAddresses();

  const haveLocation = useMemo(() => addresses.data?.some((a) => validMapPoint(a.location)) ?? false, [addresses]);

  return (
    <>
      <RemindersModal show={showReminders} setShow={setShowReminders} />
      {hasPermission(Permission.ViewReportsAll) && (
        <RecordCardsModalLazy show={showRecordCards} setShow={setShowRecordCards} />
      )}
      <NavMenu
        area="people"
        runtime={{ haveLocation }}
        onAction={(a) => {
          if (a === "reminders") setShowReminders(true);
          if (a === "recordCards") setShowRecordCards(true);
        }}
      />
    </>
  );
}
